import { render, staticRenderFns } from "./_base-hero.vue?vue&type=template&id=78dc6f52&"
import script from "./_base-hero.vue?vue&type=script&lang=js&"
export * from "./_base-hero.vue?vue&type=script&lang=js&"
import style0 from "./_base-hero.vue?vue&type=style&index=0&id=78dc6f52&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports